module.exports = __webpack_public_path__ + "media/images/logo_amex-c26b71650b781e7124f6395a38543a89.png";